@if (sourceFieldsLoaded) {
  <div>
    <form class="d-flex align-items-center mb-2" (ngSubmit)="applySearch()">
      <div class="me-auto">
        <div class="input-group search-filter">
          <rl-text-input [placeholder]="'Search'" [formControl]="searchControl"
            [dataLabel]="'selectSourceFieldsSearchInput'" [ariaLabel]="'Search Source Fields'">
            <append-with class="d-flex">
              <button [hidden]="!searchControl.value" class="btn btn-icon btn-remove" (click)="clearSearch()"
                type="button" title="Clear Search" data-cy="selectSourceFieldsSearchRemove">
                <i class="fal fa-xmark" aria-hidden="true"></i>
              </button>
              <button type="submit" class="btn btn-icon btn-info" title="Search" data-cy="selectSourceFieldsSearchSubmit">
                <i class="fal fa-magnifying-glass" aria-hidden="true"></i>
              </button>
            </append-with>
          </rl-text-input>
        </div>
      </div>
    </form>
    <div class="table-container scroll-vert">
      <table class="table rl-table table-hover" cdkDropList>
        <thead>
          <tr>
            <th class="ps-4">ID</th>
            <th class="text-nowrap">Source Field Name</th>
            <th class="text-nowrap">Tag Label</th>
            <th class="text-nowrap">Data Type</th>
            <th>Length</th>
            <th class="text-nowrap">Can be Multiple</th>
            <th class="text-nowrap">Used In</th>
          </tr>
        </thead>
        <tbody>
          @if (filteredFields.length === 0) {
            <tr>
              <td colspan="10">
                <rl-no-records-found></rl-no-records-found>
              </td>
            </tr>
          }
          @for (char of filteredFields; track char.sourceFieldID) {
            <tr>
              <td class="ps-1 text-nowrap">
                <input type="checkbox" class="form-check-input me-1" [value]="char.sourceFieldID"
                  (change)="toggleSourceField(char.sourceFieldID)" [checked]="isChecked(char.sourceFieldID)"
                  data-cy="checkboxInputToggleSourceField" />
                  {{char.sourceFieldID}}
                </td>
                <td>
                  {{char.sourceFieldName}}
                </td>
                <td>
                  {{char.mergeTag}}
                </td>
                <td>
                  {{char.dataTypeID | charDataTypeName}}
                </td>
                <td>
                  {{char.length}}
                </td>
                <td>
                  {{char.multipleIndicator | multipleIndicatorName}}
                </td>
                <td class="pb-0">
                  @if (char.usedIn.length === 0) {
                    <em class="text-grey text-nowrap">
                      Not Used
                    </em>
                  }
                  @if (char.usedIn.length > 0) {
                    <a [ngbPopover]="usedInPopover" #p="ngbPopover"
                      [autoClose]="'outside'" placement="left auto"
                      class="btn btn-link btn-icon btn-sm p-0 h-auto cursor-pointer" aria-label="Used In List"
                      role="button" data-cy="usedIn">
                      <i class="fal fa-link"></i>
                    </a>
                  }
                  <ng-template #usedInPopover>
                    <div class="scroll-vert popover-max-height">
                      @for (usedIn of char.usedIn; track usedIn) {
                        <span class="d-block my-1 text-small">
                          <span>{{char.charTypeID | charTypeName}}</span>
                          <span class="px-2">&bull;</span>
                          <span>{{usedIn.templateLbl}}</span>
                          <span class="px-2">&bull;</span>
                          <span>{{usedIn.templateSourceFieldGroupLbl}}</span>
                        </span>
                      }
                    </div>
                  </ng-template>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="border-top py-4 mt-5">
        <h4>Selected {{charTypeName}} Source Fields</h4>
        <div class="mt-2">
          @for (sourceFieldID of fieldsToAdd; track sourceFieldID) {
            <rl-chip (onRemove)="toggleSourceField(sourceFieldID)">
              {{ getSourceFieldById(sourceFieldID) }}
            </rl-chip>
          }
          @if (!fieldsToAdd) {
            <span>No Fields selected.</span>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="p-4 text-center">
      <rl-loader></rl-loader>
    </div>
  }
  <div class="modal-footer">
    <ng-content></ng-content>
    <button type="submit" class="btn btn-success ms-3" (click)="submit()" [disabled]="fieldsToAdd.size === 0"
    data-cy="saveSelectTemplateSourceField">Save</button>
  </div>

